import { type SharedData } from "@/types";
import { usePage } from "@inertiajs/react";

export function usePermissions() {
  const { auth } = usePage<SharedData>().props;
  const permissions = (auth.permissions || []) as App.Enums.PermissionEnum[];

  const hasPermission = (permission: App.Enums.PermissionEnum): boolean => {
    return permissions.includes(permission);
  };

  const hasAnyPermission = (permissionList: App.Enums.PermissionEnum[]): boolean => {
    return permissionList.some((permission) => permissions.includes(permission));
  };

  const hasAllPermissions = (permissionList: App.Enums.PermissionEnum[]): boolean => {
    return permissionList.every((permission) => permissions.includes(permission));
  };

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
}
